/* eslint-disable */
import { store } from '../../store'
import { http, httpgst } from '../../main'
import router from '../../router'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get({ commit, dispatch }, payload) {
    let url = 'api/expens_items/expenses/' + payload.event.expense_id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGet', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategoriesRelated({ commit, dispatch }, payload) {
    let url = 'api/categories-by-expense-request/' + payload.event.request_id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategoriesRelated', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getItem({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetItem', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getTip({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.id + '/tip'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetTip', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  async getTipByValidate({ commit }, { ctx, id, index }) {
    try {
      const URL = `api/expenses_items/${id}/tip`
      const OPTIONS = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${store.state.userState.access_token}`

      const { data: response } = await httpgst.get(URL, {}, OPTIONS)

      if (response.data === null) return

      const total = Number(ctx.expensesItems[index].total)
      const tip = Number(response.data.amount)
      const totalPlusTip = total + tip
      ctx.expensesItems[index].tipGet = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(totalPlusTip)
    } catch (error) {
      console.log(error)
    }
  },
  async getTipByAprobe({ commit }, { ctx, id, index }) {
    try {
      const URL = `api/expenses_items/${id}/tip`
      const OPTIONS = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      httpgst.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${store.state.userState.access_token}`

      const { data: response } = await httpgst.get(URL, {}, OPTIONS)

      if (response.data === null) return

      const total = Number(ctx.expensesItems[index].total)
      const tip = Number(response.data.amount)
      const totalPlusTip = total + tip
      ctx.expensesItemsApp[index].tip = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(totalPlusTip)
    } catch (error) {
      console.log(error)
    }
  },
  post({ commit, dispatch }, payload) {
    let url = 'api/expenses_items'
    let params = {
      gst_expenses_id: payload.event.expense_id === null || payload.event.expense_id === undefined
                      ? undefined
                      : payload.event.expense_id,
      expenses_amex_id: payload.event.expenses_amex_id === null || payload.event.expenses_amex_id === undefined
                      ? undefined
                      : payload.event.expenses_amex_id,
      subtotal: payload.event.item.subtotal,
      total: payload.event.item.total,
      description: payload.event.item.description,
      issuer_tax: payload.event.item.issuer_tax === null || payload.event.item.issuer_tax === undefined
                ? undefined
                : payload.event.item.issuer_tax,
      project_id: payload.event.item.project_id === null || payload.event.item.project_id === undefined ? undefined : payload.event.item.project_id,
      issuer_name: payload.event.item.issuer_name === null || payload.event.item.issuer_name === undefined
                ? undefined
                : payload.event.item.issuer_name,
      sat_formaPago_id: payload.event.item.sat_forma_pago.id,
      gst_receipt_types_id: payload.event.item.gst_receipt_types_id,
      folio: payload.event.item.folio === null || payload.event.item.folio === undefined || payload.event.item.folio === ''
          ? undefined
          : payload.event.item.folio,
      sat_metodoPago_id: payload.event.item.sat_metodo_pago === null || payload.event.item.sat_metodo_pago === undefined
                      ? undefined
                      : payload.event.item.sat_metodo_pago.id,
      comment: payload.event.item.comment,
      gst_categories_id: payload.event.item.gst_categories_id,
      is_refund: payload.event.item.is_refund,
      country: payload.event.item.country.id,
      currency: payload.event.item.currency.id,
      exchange: payload.event.item.exchange,
      date: payload.event.item.date,
      file_id: payload.event.item.fileId
      
    }
    
    if (payload.event.item.gst_receipt_types_id === 1) {
      params.uuid = payload.event.item.uuid
      params.validity = payload.event.item.validity
      params.validity_date = payload.event.item.validity_date
      params.discount = payload.event.item.discount
      params.TotalImpuestosRetenidos =
        payload.event.item.TotalImpuestosRetenidos
    }
    
    if(payload.event.item.gst_receipt_types_id === 3){
      params.sat_formaPago_id = payload.event.item.sat_formaPago_id
      // params.foreign_tax = payload.event.item.foreign_tax 
      params.item_lines = payload.event.item.item_lines
      params.vendor_id = payload.event.item.vendor.id
    }

    if (payload.event.item.item_lines.length > 0) {
      params.item_lines = payload.event.item.item_lines
    }

    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        // var fileId = payload.event.context.editedItem.fileId
        // var expenseItemId = response.data.data.id
        if (
          payload.event.has_next &&
          payload.event.item.gst_receipt_types_id === 1
        ) {
          commit('onPostNext', { event: payload.event, response: response })
        } else {
          commit('onPost', { event: payload.event, response: response })
        }
        // dispatch('postFile', {
        //   event: {
        //     context: payload.event.context,
        //     file_id: fileId,
        //     expense_item_id: expenseItemId
        //   }
        // })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  postFromExcluded({ commit, dispatch }, payload) {
    let url = 'api/expenses_items'
    let params = {
      gst_expenses_id: payload.event.expense_id === null || payload.event.expense_id === undefined ? undefined : payload.event.expense_id,
      tip_amount: payload.event.item.tip_amount === null || payload.event.item.tip_amount === undefined || payload.event.item.tip_amount === '' ? undefined : payload.event.item.tip_amount,
      tip_file_id: payload.event.item.tip_file_id === null || payload.event.item.tip_file_id === undefined ? undefined : payload.event.item.tip_file_id,
      expenses_amex_id:
        payload.event.expenses_amex_id === null ||
        payload.event.expenses_amex_id === undefined
          ? undefined
          : payload.event.expenses_amex_id,
      subtotal: payload.event.item.subtotal,
      total: payload.event.item.total,
      description: payload.event.item.description,
      issuer_tax:
        payload.event.item.issuer_tax === null ||
        payload.event.item.issuer_tax === undefined
          ? undefined
          : payload.event.item.issuer_tax,
      issuer_name:
        payload.event.item.issuer_name === null ||
        payload.event.item.issuer_name === undefined
          ? undefined
          : payload.event.item.issuer_name,
      sat_formaPago_id: payload.event.item.sat_forma_pago.id,
      gst_receipt_types_id: payload.event.item.gst_receipt_types_id,
      folio:
        payload.event.item.folio === null ||
        payload.event.item.folio === undefined ||
        payload.event.item.folio === ''
          ? undefined
          : payload.event.item.folio,
      sat_metodoPago_id:
        payload.event.item.sat_metodo_pago === null ||
        payload.event.item.sat_metodo_pago === undefined
          ? undefined
          : payload.event.item.sat_metodo_pago.id,
      comment: payload.event.item.comment,
      gst_categories_id: payload.event.item.gst_categories_id,
      is_refund: payload.event.item.is_refund,
      country: payload.event.item.country.id,
      currency: payload.event.item.currency.id,
      exchange: payload.event.item.exchange,
      date: payload.event.item.date,
      file_id: payload.event.item.fileId
    }
    if (payload.event.item.gst_receipt_types_id === 1) {
      params.uuid = payload.event.item.uuid
      params.validity = payload.event.item.validity
      params.validity_date = payload.event.item.validity_date
      params.discount = payload.event.item.discount
      params.TotalImpuestosRetenidos =
        payload.event.item.TotalImpuestosRetenidos
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        if (
          payload.event.has_next &&
          payload.event.item.gst_receipt_types_id === 1
        ) {
          commit('onPostNext', { event: payload.event, response: response })
        } else {
          commit('onPostFromExcluded', {
            event: payload.event,
            response: response
          })
        }
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  postTip({ commit, dispatch }, payload) {
    let url = 'api/expenses_items_tips'
    let params = {
      gst_expenses_items_id: payload.event.item.id,
      files_id: payload.event.item.fileId,
      amount: payload.event.item.amount
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onPostTip', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  put({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.item.id
    let params = {
      gst_expenses_id: payload.event.expense_id,
      subtotal: payload.event.item.subtotal,
      total: payload.event.item.total,
      description: payload.event.item.description,
      issuer_tax:
        payload.event.item.issuer_tax === null ||
        payload.event.item.issuer_tax === undefined
          ? undefined
          : payload.event.item.issuer_tax,
      project_id: payload.event.item.project_id === null || payload.event.item.project_id === undefined ? undefined : payload.event.item.project_id,
      issuer_name:
        payload.event.item.issuer_name === null ||
        payload.event.item.issuer_name === undefined
          ? undefined
          : payload.event.item.issuer_name,
      sat_formaPago_id: payload.event.item.sat_forma_pago !== null ? payload.event.item.sat_forma_pago.id : undefined,
      gst_receipt_types_id: payload.event.item.gst_receipt_types_id,
      folio:
        payload.event.item.folio === null ||
        payload.event.item.folio === undefined ||
        payload.event.item.folio === ''
          ? undefined
          : payload.event.item.folio,
      sat_metodoPago_id:
        payload.event.item.sat_metodo_pago === null ||
        payload.event.item.sat_metodo_pago === undefined
          ? undefined
          : payload.event.item.sat_metodo_pago.id,
      comment: payload.event.item.comment,
      gst_categories_id: payload.event.item.gst_categories_id,
      is_refund: payload.event.item.is_refund,
      country: payload.event.item.country.id,
      currency: payload.event.item.currency.id,
      exchange: payload.event.item.exchange,
      date: payload.event.item.date
    }

    if (payload.event.item.gst_receipt_types_id === 1) {
      params.uuid = payload.event.item.uuid
      params.validity = payload.event.item.validity
      params.validity_date = payload.event.item.validity_date
      params.item_lines = payload.event.item.item_lines
    }

    if (payload.event.item.fileId) {
      params.file_id = payload.event.item.fileId
    }

    if(payload.event.item.gst_receipt_types_id === 3){
      params.sat_formaPago_id = payload.event.item.sat_formaPago_id
      // params.foreign_tax = payload.event.item.foreign_tax 
      params.item_lines = payload.event.item.item_lines
      params.vendor_id = payload.event.item.vendor.id
    }
    
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {}).then(
      response => {
        commit('onPut', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  delete({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {}).then(
      response => {
        commit('onDelete', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  deleteConcept({ commit, dispatch }, payload) {
    let url = 'api/expenses_items/line/' + payload.event.id
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {}).then(
      response => {
        commit('onDeleteConcept', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  getCategories({ commit, dispatch }, payload) {
    payload.event.context.loadingCategories = true
    let url = 'api/categories-list'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetCategories', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  postFile({ commit, dispatch }, payload) {
    let url = 'api/expenses_items_files'
    let params = {
      gst_expenses_items_id: payload.event.expense_item_id,
      files_id: payload.event.file_id
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        // commit('onPostFile', {event: payload.event, response: response})
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  attachFiles({ commit, dispatch }, payload) {
    let url = `api/attachment-expenses-item/${payload.event.id}`
    let params = {
      attach_file: payload.event.items
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {}).then(
      response => {
        commit('onAttachFiles', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  readXmlQueueItem({ commit, dispatch }, payload) {
    let url = 'api/read-xml'
    let params = {
      file_id: payload.event.file_id,
      files_type_id: 7
    }
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params, options).then(
      response => {
        commit('onReadXmlQueueItem', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onReadXmlErrorQueueItem', {
          event: payload.event,
          error: error
        })
      }
    )
  },
  getXmlread({ commit, dispatch }, payload) {
    let url = 'api/xml-read/' + payload.event.fileId
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
      http.get(url, options).then(
      response => {
        commit('onGetXmlread', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  readXmlQueueItemFromExcluded({ commit, dispatch }, payload) {
    let url = 'api/read-xml'
    let params = {
      file_id: payload.event.file_id,
      files_type_id: 7
    }
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    http.post(url, params, options).then(
      response => {
        commit('onReadXmlQueueItemFromExcluded', {
          event: payload.event,
          response: response
        })
      },
      error => {
        commit('onReadXmlErrorQueueItem', {
          event: payload.event,
          error: error
        })
      }
    )
  },
  getById({ commit, dispatch }, payload) {
    let url = 'api/expenses/' + payload.event.expense_id
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] =
      'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options).then(
      response => {
        commit('onGetById', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the expensesItems endpoint
  onGet(state, payload) {
    payload.event.context.filteredExpenseItems = payload.response.data.data.sort((a, b) => a.project_id - b.project_id)

    if(payload.event.context.filteredExpenseItems.length > 0 && payload.event.context.filteredExpenseItems && payload.event.context.filteredExpenseItems[0].gst_expenses.has_multiprojects === 1){
      const processed = {}
        payload.event.context.filteredExpenseItems.forEach(item => {
          if (item.project_id && !processed[item.project_id]) {
              item.isTitle = true
              processed[item.project_id] = true
          } else {
              item.isTitle = false
          }
        })
    }
    
    payload.event.context.expenseItemsFilter()
    payload.event.context.disableCategories()
    payload.event.context.loadingItems = false
  },
  onGetById(state, payload) {
    payload.event.context.expense = payload.response.data.data
  },
  onGetCategoriesRelated(state, payload) {
    let categories = []
    const response = Object.assign({}, payload.response.data.data)
    const listCategories = Object.getOwnPropertyNames(response)
    listCategories.forEach(i => {
      let el = response[i]
      el = {
        ...el
      }
      if (el.gst_categories_by_request_id) {
        categories.push(el)
      }
    })
    payload.event.context.categoriesRelated = categories
    payload.event.context.disableCategories()
  },
  onGetItem(state, payload) {
    payload.event.context.loadItem = false
    payload.event.context.editedItem = payload.response.data.data
    payload.event.context.editedItemFile = payload.response.data.data // Agregado para el caso de que se abra con un dialog
  },
  onGetTip(state, payload) {
    payload.event.context.loadItem = false
    if (payload.response.data.data) {
      payload.event.context.editedItemTip = payload.response.data.data
      payload.event.context.editedItemTip.fileId =
        payload.response.data.data.files_id
      payload.event.context.getFile(payload.response.data.data.files_id)
    }
  },
  // Add the data from the new expenseItem to the expensesItems list
  onPost(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.reset()
    payload.event.context.closeDialog()
    payload.event.context.closeDialogExpenseUniversal()
    // payload.event.context.resetXML()
    payload.event.context.closeDialogXML()
    payload.event.context.postTipExpense(payload.response.data.data.id)
    payload.event.context.refresh()
    payload.event.context.getExpenseById()
  },
  onPostFromExcluded(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.reset()
    payload.event.context.closeDialog()
    payload.event.context.closeDialogXML()
    payload.event.context.postTipExpense(payload.response.data.data.id)
    payload.event.context.get()
  },
  onPostTip(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDialogTip()
    payload.event.context.refresh()
  },
  onPostNext(state, payload) {
    if(payload.event.context.expensesAmexSelected) {
      let expense_item_back = {
        "id": payload.response.data.data.id,
        "expenses_amex_id": payload.response.data.data.expenses_amex_id,
        "subtotal": payload.response.data.data.subtotal,
        "total": payload.response.data.data.total,
        "total_mxn": null,
        "uuid": payload.response.data.data.uuid,
        "exchange": payload.response.data.data.exchange,
        "discount": payload.response.data.data.discount,
        "tip_amount": payload.response.data.data.tip_amount === undefined ? null : payload.response.data.data.tip_amount,
        "tip_file_id": payload.response.data.data.tip_file_id === undefined ? null : payload.response.data.data.tip_file_id
      }
  
      payload.event.context.expensesAmexSelected.amex_expense.expense_item_back.push(expense_item_back)
      // CALCULOS PARA PERMITIR AGREGAR GASTO
      const amount = parseFloat(payload.event.context.expensesAmexSelected.amex_expense.amount)
  
      const totalSum = payload.event.context.expensesAmexSelected.amex_expense.expense_item_back.reduce((sum, item) => {
        const total = parseFloat(item.total) || 0;
        const tipAmount = parseFloat(item.tip_amount) || 0;
        return sum + total + tipAmount;
      }, 0)
  
      payload.event.context.errorAmount = (parseFloat(payload.event.context.editedItemExpense.total) + parseFloat(totalSum)) > amount
    }

    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.showNextUpload()
  },
  onAttachFiles(state, payload) {
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    setTimeout(() => {
      router.back()
    }, 1000)
  },
  // Updates the data displayed for the modified user
  onPut(state, payload) {
    if(payload.event.context.page === 'expenseValidate') {
      payload.event.context.showNotification(payload.response, 'success')
      payload.event.context.close()
      payload.event.context.refresh()
      return
    } 
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.reset()
    payload.event.context.closeDialog()
    payload.event.context.closeDialogExpenseUniversal()
    payload.event.context.refresh()
    payload.event.context.getExpenseById()
  },
  // Removes the data of the deleted expenseItem from the expensesItems list
  onDelete(state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.reset()
    payload.event.context.closeRemove()
    payload.event.context.refresh()
    payload.event.context.getExpenseById()
  },
  onDeleteConcept(state, payload){
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.updateDataUniversal(payload.response)
  },
  onGetCategories(state, payload) {
    let categories = payload.response.data.data
    payload.event.context.categories = categories
    payload.event.context.loadingCategories = false

  },
  // Shows a error message
  onError(state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.loading = false
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loadingItems = false
  },
  onReadXmlQueueItem(state, payload) {
    let readXml = payload.response.data.data
    payload.event.context.fileId = readXml
    payload.event.context.conceptos = payload.response.data.data.Conceptos
    payload.event.context.readXml = readXml
    let satFormaPago = payload.event.context.getSatFormaPago(
      readXml.Comprobante.FormaPago
    )
    let satMetodoPago = payload.event.context.getSatMetodoPago(
      readXml.Comprobante.MetodoPago
    )
    let currency = payload.event.context.getCurrency(readXml.Comprobante.Moneda)
    let country = payload.event.context.getCountry('MEX')
    let porDefinir = {
      id: 22,
      descripcion: 'Por definir'
    }

    let categoryDefault = readXml.category.id

    if(payload.event.context.existFeature('DEFAULT_CATEGORY_REFUND') && parseFloat(payload.event.context.expense.advance) <= 0 && payload.event.context.expense.is_petty_cash === 0) categoryDefault = parseInt(store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_REFUND').pivot.param1)

    if(payload.event.context.existFeature('DEFAULT_CATEGORY_TRAVEL_EXPENSE') && payload.event.context.expense.is_imported_expense === 1) categoryDefault = parseInt(store.state.userLogged.company[0].features.find(x => x.name === 'DEFAULT_CATEGORY_TRAVEL_EXPENSE').pivot.param1)

    payload.event.context.editedItem = {
      gst_receipt_types_id: 1,
      gst_categories: categoryDefault,
      is_refund: false,
      comment: '',
      description: readXml.Conceptos[0].Descripcion,
      date: readXml.Comprobante.Fecha.substr(0, 10),
      currency: currency,
      exchange: readXml.Comprobante.Moneda === 'MXN' ? '1' : '',
      subtotal: readXml.Comprobante.SubTotal,
      total: readXml.Comprobante.Total,
      issuer_tax: readXml.Emisor.Rfc,
      issuer_name: readXml.Emisor.Nombre,
      sat_forma_pago: readXml.Comprobante.FormaPago ? satFormaPago : porDefinir,
      sat_metodo_pago: satMetodoPago,
      folio: readXml.Comprobante.Folio,
      country: country,
      uuid: readXml.TimbreDigitalFiscal.UUID,
      validity: readXml.Estado === 'Vigente',
      emisor: readXml.Emisor ? readXml.Emisor.Nombre : '',
      validity_date: readXml.TimbreDigitalFiscal.FechaTimbrado.substr(0, 10),
      fileId: payload.event.file_id,
      discount: readXml.Comprobante.Descuento
    }
    const impuestos = Object.assign({}, readXml.Impuestos)
    let totalImpuestos = 0
    if (impuestos.Total && impuestos.Total[0]) {
      const list = Object.getOwnPropertyNames(impuestos.Total[0])
      list.pop()
      list.forEach(el => {
        totalImpuestos = totalImpuestos + parseFloat(impuestos.Total[0][el])
      })
    }
    if (impuestos.ISH[0]) {
      totalImpuestos = totalImpuestos + parseFloat(impuestos.ISH[0].Importe)
    }
    payload.event.context.editedItem.TotalImpuestosRetenidos = totalImpuestos
    if (readXml.satListaNegraStatus.isInListaNegra) {
      let data = readXml.satListaNegraStatus.data
      let msg = `${payload.event.context.$t('expenseItems.blackList')} - ${
        data.razon_social
      } - ${data.tax_id} - ${data.status}`
      payload.event.context.showNotification(msg, 'warning', -1)
    }
  },
  // DECRAPED METHOD
  onGetXmlread(state, payload) {
    let fileId = payload.response.data.data
    payload.event.context.fileId = fileId
    payload.event.context.conceptos = payload.response.data.data.Conceptos
  },
  onReadXmlQueueItemFromExcluded(state, payload) {
    let readXml = payload.response.data.data
    payload.event.context.readXml = readXml
    let satFormaPago = payload.event.context.getSatFormaPago(
      readXml.Comprobante.FormaPago
    )
    let satMetodoPago = payload.event.context.getSatMetodoPago(
      readXml.Comprobante.MetodoPago
    )
    let currency = payload.event.context.getCurrency(readXml.Comprobante.Moneda)
    let country = payload.event.context.getCountry('MEX')
    let porDefinir = {
      id: 22,
      descripcion: 'Por definir'
    }
    payload.event.context.editedItemExpense = {
      gst_receipt_types_id: 1,
      gst_categories_id: readXml.category.id,
      is_refund: false,
      comment: '',
      description: readXml.Conceptos[0].Descripcion,
      date: readXml.Comprobante.Fecha.substr(0, 10),
      currency: currency,
      exchange: readXml.Comprobante.Moneda === 'MXN' ? '1' : '',
      subtotal: readXml.Comprobante.SubTotal,
      total: readXml.Comprobante.Total,
      issuer_tax: readXml.Emisor.Rfc,
      issuer_name: readXml.Emisor.Nombre,
      sat_forma_pago: readXml.Comprobante.FormaPago ? satFormaPago : porDefinir,
      sat_metodo_pago: satMetodoPago,
      folio: readXml.Comprobante.Folio,
      country: country,
      uuid: readXml.TimbreDigitalFiscal.UUID,
      validity: readXml.Estado === 'Vigente',
      emisor: readXml.Emisor ? readXml.Emisor.Nombre : '',
      validity_date: readXml.TimbreDigitalFiscal.FechaTimbrado.substr(0, 10),
      fileId: payload.event.file_id,
      discount: readXml.Comprobante.Descuento
    }
    const impuestos = Object.assign({}, readXml.Impuestos)
    let totalImpuestos = 0
    if (impuestos.Total && impuestos.Total[0]) {
      const list = Object.getOwnPropertyNames(impuestos.Total[0])
      list.pop()
      list.forEach(el => {
        totalImpuestos = totalImpuestos + parseFloat(impuestos.Total[0][el])
      })
    }
    if (impuestos.ISH[0]) {
      totalImpuestos = totalImpuestos + parseFloat(impuestos.ISH[0].Importe)
    }
    payload.event.context.editedItemExpense.TotalImpuestosRetenidos = totalImpuestos
    if (readXml.satListaNegraStatus.isInListaNegra) {
      let data = readXml.satListaNegraStatus.data
      let msg = `${payload.event.context.$t('expenseItems.blackList')} - ${data.razon_social} - ${data.tax_id} - ${data.status}`
      payload.event.context.showNotification(msg, 'warning', -1)
    }

    // CALCULOS PARA PERMITIR AGREGAR GASTO
    const amount = parseFloat(payload.event.context.expensesAmexSelected.amex_expense.amount)

      const totalSum = payload.event.context.expensesAmexSelected.amex_expense.expense_item_back.reduce((sum, item) => {
        const total = parseFloat(item.total) || 0;
        const tipAmount = parseFloat(item.tip_amount) || 0;
        return sum + total + tipAmount;
      }, 0)

      payload.event.context.errorAmount = (parseFloat(payload.event.context.editedItemExpense.total) + parseFloat(totalSum)) > amount

    // payload.event.context.get()
  },
  onReadXmlErrorQueueItem(state, payload) {
    payload.event.context.loadingFile = false
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.showNextUpload()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expensesItems.js